module.exports = __webpack_public_path__ + "static/img/PT.e6b93577.png";